import React, { useEffect, useState } from "react";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { SideMenuLinks } from "./SideMenuLinks";
import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { handleLogout } from "@/utils/sharedHelperFunctions";
import { Box, Flex, Separator, Text } from "@radix-ui/themes";
import { ExitIcon } from "@radix-ui/react-icons";
import useViewportWidth from "@/hooks/useViewportWidth";
import { useAtomValue } from "jotai";
import { clientAtom } from "@/utils/atoms/atomClient";
import { findPartner } from "@/utils/constants/findPartner";

const SideMenuUi: React.FunctionComponent<{ currentViewName: any }> = ({
  currentViewName,
}) => {
  const navigate = useNavigate();
  const setProfile = useCurrentUserProfile((s) => s.setUser);
  const [logoURL, setLogoURL] = useState(brand.logos.large);

  const currentClient = useAtomValue(clientAtom);
  const hasClient = currentClient !== "";

  useEffect(() => {
    if (hasClient) {
      // setLogoURL(Logitech_zoneRoutes as any);
      findPartner(currentClient) &&
        setLogoURL(findPartner(currentClient).logo.large);
    } else {
      setLogoURL(brand.logos.large);
    }
  }, [currentClient]);

  const isMobile = useViewportWidth(768);

  return (
    <>
      {!isMobile && (
        <Box
          className="primary-nav"
          position="fixed"
          inset="0 auto 0 0"
          width="300px"
          px="5"
          pt="3"
          pb="5"
        >
          <Flex direction="column" justify="between" minHeight="100%">
            <Flex direction="column" gap="3">
              <Flex
                className="primary-nav__brand"
                justify="center"
                mt="3"
                asChild
                px="5"
              >
                <Flex direction="column" align="center" gap="3">
                  {hasClient && (
                    <Link
                      to="/home"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <img
                        src={brand.logos.white}
                        alt={brand.logos.alt_text}
                        style={{ display: "flex", width: "60%" }}
                      />
                    </Link>
                  )}
                  <Link
                    to={
                      hasClient
                        ? `${siteRoutes["zone"]}${
                            findPartner(currentClient).route
                          }`
                        : "/home"
                    }
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "80%",
                    }}
                  >
                    {logoURL && (
                      <img
                        src={logoURL}
                        alt={brand.logos.alt_text}
                        style={{ display: "flex", width: "100%" }}
                      />
                    )}
                  </Link>
                </Flex>
              </Flex>

              <Box>
                <Box py="4">
                  <Separator decorative style={{ width: "100%" }} />
                </Box>

                <SideMenuLinks currentViewName={`${currentViewName}`} />

                <Box py="4">
                  <Separator decorative style={{ width: "100%" }} />
                </Box>
              </Box>
            </Flex>

            <div className="primary-nav__footer">
              <Box
                asChild
                className="primary-nav__item"
                style={{ cursor: "var(--cursor-link)" }}
                onClick={async () => {
                  await handleLogout(setProfile);
                  navigate(siteRoutes["login"]);
                }}
              >
                <Flex gap="2" align="center">
                  <ExitIcon />
                  <Text size="2">{i18next.t("buttons.log_out")}</Text>
                </Flex>
              </Box>
            </div>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default SideMenuUi;
